import { ApolloLink } from '@apollo/client';
import * as Sentry from 'shared/domains/sentry';
export const sentryLink = new ApolloLink((operation, forward) => {
    const traceData = Sentry.getTraceData();
    operation.setContext(({ headers = {} }) => ({
        headers: Object.assign(Object.assign({}, headers), { 'x-correlation-id': traceData['sentry-trace'] }),
    }));
    return forward(operation);
});
